export default __webpack_public_path__ + "static/media/42_desktop.54b068b1.jpg";